import React from 'react';
import { useThemeMode } from '../../ThemeContext';
import { usePermissions } from '../../contexts/PermissionContext';
import DeleteIcon from '@mui/icons-material/Delete';

const TaskOptionsMenu = ({ 
  task, 
  onDelete, 
  anchorEl, 
  onClose, 
  onOpen 
}) => {
  const { mode } = useThemeMode();
  const { hasDeletePermission } = usePermissions();

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete && onDelete(task);
    onClose();
  };

  // Don't render menu if user doesn't have delete permission
  if (!hasDeletePermission('task')) {
    return null;
  }

  return (
    <div style={{ position: 'relative' }}>
      {/* Three dots button */}
      <button
        onClick={onOpen}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          borderRadius: '4px',
          color: mode === 'dark' ? '#FFFFFF' : '#666666',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = mode === 'dark' ? '#333' : '#f0f0f0';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'transparent';
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
        </svg>
      </button>

      {/* Options Menu */}
      {anchorEl && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1000
            }}
            onClick={onClose}
          />
          
          {/* Menu */}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              backgroundColor: mode === 'dark' ? '#2a2a2a' : '#ffffff',
              border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
              borderRadius: '8px',
              boxShadow: mode === 'dark' 
                ? '0 4px 20px rgba(0, 0, 0, 0.5)' 
                : '0 4px 20px rgba(0, 0, 0, 0.15)',
              zIndex: 1001,
              minWidth: '160px',
              padding: '8px 0'
            }}
          >
            {/* Delete Option */}
            <button
              onClick={handleDeleteClick}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 16px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: mode === 'dark' ? '#FFFFFF' : '#222222',
                fontSize: '14px',
                fontFamily: 'Urbanist, Arial, sans-serif',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = mode === 'dark' ? '#333' : '#f5f5f5';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              <DeleteIcon style={{ fontSize: '18px', color: '#f44336' }} />
              Delete Task
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default TaskOptionsMenu;
